export default __webpack_public_path__ + "static/media/surroundings.787519ee.svg";